import React from 'react';
import { push } from 'connected-react-router';
import { QualificationInfoDetails } from 'components';
import { useLocalErrorHandler } from 'hooks';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { connect } from 'react-redux';

const QualificationDetailContainer = ({
    apiError, 
    onPush, 
    setErrorHandler, 
    getQualificationDetails, 
    examApplicationId, 
    applicantQualificationDetails,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    React.useEffect(() => {
        const fetch = async () => {
            await getQualificationDetails(examApplicationId);
        };

        fetch();
    }, []);

    return applicantQualificationDetails ? (
        <QualificationInfoDetails
            qualificationDetails={applicantQualificationDetails}
            onBackClick={() => onPush('/expert-qualifications')}
        />
    ) : null;
};

const mapState = (state: IRootState) => ({
    applicantQualificationDetails: state.expert.applicantQualificationDetails,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    getQualificationDetails: dispatch.expert.getQualificationDetailsAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(QualificationDetailContainer);

interface IProps {
    examApplicationId: string;
}

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch> & IProps;
type Props = connectedProps;
